import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiLoader } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';

import { LogoutModalComponent } from './ui/logout-modal/logout-modal.component';

@NgModule({
  declarations: [LogoutModalComponent],
  imports: [CommonModule, TuiLoader, TranslateModule],
})
export class AuthModule {}
